"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SectionTitle_1 = __importDefault(require("@/Jetstream/SectionTitle"));
function JetActionSection(_a) {
    var title = _a.title, description = _a.description, children = _a.children;
    return (react_1.default.createElement("div", { className: "md:grid md:grid-cols-3 md:gap-6" },
        react_1.default.createElement(SectionTitle_1.default, { title: title, description: description }),
        react_1.default.createElement("div", { className: "mt-5 md:mt-0 md:col-span-2" },
            react_1.default.createElement("div", { className: "px-4 py-5 sm:p-6 bg-white shadow sm:rounded-lg" }, children))));
}
exports.default = JetActionSection;
